import axios from 'axios';

const API_BASE_URL = '/api';
const AI_BASE_URL = '/ai';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const aiApi = axios.create({
  baseURL: AI_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ═══════════════════════════════════════════════════════════════
// QUESTIONS API
// ═══════════════════════════════════════════════════════════════

export const questionService = {
  // Buscar todas as questões
  getAllQuestions: async () => {
    const response = await api.get('/questions');
    return response.data;
  },

  // Buscar questão por ID
  getQuestionById: async (id) => {
    const response = await api.get(`/questions/${id}`);
    return response.data;
  },

  // Contar questões
  countQuestions: async (sourceType = null, sourceName = null) => {
    const params = {};
    if (sourceName) params.sourceName = sourceName;
    else if (sourceType) params.sourceType = sourceType;
    const response = await api.get('/questions/count', { params });
    return response.data;
  },

  // Buscar questões por tipo de fonte
  getQuestionsBySourceType: async (sourceType) => {
    const response = await api.get('/questions/filter', { params: { sourceType } });
    return response.data;
  },

  // Buscar questões por nome da fonte
  getQuestionsBySourceName: async (sourceName) => {
    const response = await api.get('/questions/filter', { params: { sourceName } });
    return response.data;
  },

  // Buscar por categoria
  getQuestionsByCategory: async (categoryId) => {
    const response = await api.get(`/questions/category/${categoryId}`);
    return response.data;
  },

  // Buscar por fonte
  getQuestionsBySource: async (sourceId) => {
    const response = await api.get(`/questions/source/${sourceId}`);
    return response.data;
  },
};

// ═══════════════════════════════════════════════════════════════
// SOURCES API
// ═══════════════════════════════════════════════════════════════

export const sourceService = {
  // Buscar todos os dumps
  getDumps: async () => {
    const response = await api.get('/sources/dumps');
    return response.data;
  },

  // Buscar todas as fontes
  getAllSources: async () => {
    const response = await api.get('/sources');
    return response.data;
  },

  // Buscar fontes por tipo
  getSourcesByType: async (type) => {
    const response = await api.get(`/sources/type/${type}`);
    return response.data;
  },
};

// ═══════════════════════════════════════════════════════════════
// EXAMS API
// ═══════════════════════════════════════════════════════════════

export const examService = {
  // Criar novo simulado
  createExam: async (examData) => {
    const response = await api.post('/exams', examData);
    return response.data;
  },

  // Buscar todos os simulados
  getAllExams: async () => {
    const response = await api.get('/exams');
    return response.data;
  },

  // Buscar simulado por ID
  getExamById: async (id) => {
    const response = await api.get(`/exams/${id}`);
    return response.data;
  },

  // Buscar simulados completos
  getCompletedExams: async () => {
    const response = await api.get('/exams/completed');
    return response.data;
  },

  // Iniciar simulado
  startExam: async (id) => {
    const response = await api.post(`/exams/${id}/start`);
    return response.data;
  },

  // Completar simulado
  completeExam: async (id, score) => {
    const response = await api.post(`/exams/${id}/complete`, { score });
    return response.data;
  },
};

// ═══════════════════════════════════════════════════════════════
// AI API
// ═══════════════════════════════════════════════════════════════

export const aiService = {
  // Sugerir resposta para uma questão
  answerQuestion: async (payload) => {
    const response = await aiApi.post('/answer', payload);
    return response.data;
  },

  // Perguntar algo aberto para a IA
  askQuestion: async (payload) => {
    const response = await aiApi.post('/ask', payload);
    return response.data;
  },
};

export default api;
